<section class="drop-button">
  <button class="button" #buttonRef (click)="toggleDropdown()">
    <section class="items">
      @if (multiSelect() && selectedItems() && selectedItems().length) {
        @for (item of selectedItems(); track item; let last = $last) {
          <ng-container *ngTemplateOutlet="headTemplate() ?? template(); context: { $implicit: item }"></ng-container>
          @if (!last) {
            <span class="separator">,</span>
          }
        }
      } @else if (!multiSelect() && selectedItems()) {
        <ng-container *ngTemplateOutlet="headTemplate() ?? template(); context: { $implicit: selectedItems() }"></ng-container>
      } @else {
        <span class="placeholder">
          <ng-content select="[core-placeholder]"></ng-content>
        </span>
      }
    </section>

    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" [class.rotate]="dropIsOpen" class="drop-state_icon">
      <path d="M1 1.5L6 6.5L11 1.5" stroke="#AEAEAE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
  @if (dropIsOpen) {
    <ul class="dropdown-list showDropDownList" #dropdownList [class.upwards]="openUpwards">
      <ng-content select="[list-alert]"></ng-content>
      @for (item of items(); track item) {
        <li (click)="onClick($event, item)" (keydown.enter)="onClick($event, item)" [class.selected]="checkSelected(item)" tabindex="0">
          <section class="center w-100">
            <ng-container *ngTemplateOutlet="template(); context: { $implicit: item }"></ng-container>
          </section>
          @if (checkSelected(item)) {
            <section class="checkmark">
              <span class="icon-check"></span>
            </section>
          }
        </li>
      }
    </ul>
  }
</section>
